import React from "react";
import { TableRow, TableCell, Typography, useTheme } from "@mui/material";
import ToggleIcon from "../../Components/ToggleIcon";
import useDeleteData from "../../hooks/useDeleteData";
import ToggleIconLink from "../../Components/ToggleIconLink";
import { IUser } from "./types";
import { useTranslation } from "react-i18next";

interface IUserListItemProps {
  user: IUser;
}

const UserListItem = (props: IUserListItemProps) => {
  const { user } = props;
  const { t } = useTranslation();
  const deleteHandler = useDeleteData(
    t("User USER", { user }),
    `/users/${user.id}`
  );
  const { palette } = useTheme();

  return (
    <TableRow data-cy={`user-${user.id}`}>
      <TableCell>
        <Typography data-cy="user-username">{user.username}</Typography>
        <Typography variant="body2" data-cy="user-email">
          {user.email}
        </Typography>
      </TableCell>
      <TableCell align="center">
        {!user.is_admin && (
          <ToggleIcon
            name={"delete"}
            onClick={deleteHandler}
            color={palette.primary.main}
            data-cy="user-delete"
          />
        )}
      </TableCell>
      <TableCell align="center">
        <ToggleIconLink
          to={`/users/${user.id}`}
          name={"pencil"}
          color={palette.primary.main}
          data-cy="user-edit"
        />
      </TableCell>
    </TableRow>
  );
};

export default UserListItem;
